/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Contactprompt1Inputs */

const he_faq_contactprompt1 = /** @type {(inputs: Faq_Contactprompt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צרו איתנו קשר ונשמח לעזור לכם`)
};

const en_faq_contactprompt1 = /** @type {(inputs: Faq_Contactprompt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get in touch and we'll be happy to help`)
};

/**
* | output |
* | --- |
* | "Get in touch and we'll be happy to help" |
*
* @param {Faq_Contactprompt1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const faq_contactprompt1 = /** @type {((inputs?: Faq_Contactprompt1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Contactprompt1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_faq_contactprompt1(inputs)
	return en_faq_contactprompt1(inputs)
});
export { faq_contactprompt1 as "faq_contactPrompt" }